import './SystemDocumentationCard.css'
import React from 'react'
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeader';
import CardIcon from '../../../components/Card/CardIcon';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { connect } from "react-redux";
import { getFileAccounts, setFileAccounts } from "../../stores/actions/dashboardActions";
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '../../../components/CustomButtons/ButtonTS';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';



class FileAccess extends React.Component {

    state = {
        pickedAccounts: null,
        originalPickedAccounts: null
    };


    handleSelectChange = (email: string) => (event) => {
        const { pickedAccounts } = this.state;
        const isChecked = event.target.checked;
        const newSelectedAccountsEmails = [...pickedAccounts];
    
        if (isChecked) {
            newSelectedAccountsEmails.push(email);
        } else {
            const index = newSelectedAccountsEmails.indexOf(email);
            if (index !== -1) {
                newSelectedAccountsEmails.splice(index, 1);
            }
        }
        this.setState({ pickedAccounts: newSelectedAccountsEmails });
    };

    submitForm = () => {

        const { pickedAccounts, originalPickedAccounts } = this.state;

        // kto został dodany
        const added =  pickedAccounts.filter(email => !originalPickedAccounts.includes(email));
        // kto został usunięty
        const removed = originalPickedAccounts.filter(email => !pickedAccounts.includes(email));

        const emailToIdMap = {};
        this.props.fileAccounts.forEach(a => { emailToIdMap[a.accountEmail] = a.accountId });

        const changes = [
            ...added.map(email => ({ account_id: emailToIdMap[email], grant: true })),
            ...removed.map(email => ({ account_id: emailToIdMap[email], grant: false }))
        ];

        if (changes.length === 0) {
            console.log('no changes, orig, changed', this.state.originalPickedAccounts, this.state.pickedAccounts);
            this.props.setModifyAccessAlert(<></>);
            return;
        }
        this.props.setFileAccounts(this.props.file.id, changes, this.props.systemID);
        this.props.setModifyAccessAlert(<></>);
	};

    render() {
        if (!this.props.fileAccounts || !this.props.fileAccounts.length) {
            return null;
        }
        if (this.state.pickedAccounts === null && this.props.fileAccounts.length) {
            const selectedAccounts = _.filter([...this.props.fileAccounts], {hasAccess: true});
            const selectedAccountsEmails = [...selectedAccounts].map((fileAccount) => fileAccount.accountEmail);
            this.setState({
                pickedAccounts: selectedAccountsEmails,
                originalPickedAccounts: selectedAccountsEmails
            });
            return null;

        }
        const { fileAccounts, file, setModifyAccessAlert } = this.props;
        const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
        const checkedIcon = <CheckBoxIcon fontSize='small' />;

        return (
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <GroupAddOutlinedIcon />
                </CardIcon>
                <h3  style={{color: 'black'}}>
                    {`${file.filename}`}
                </h3>
            </CardHeader>
            <CardBody>
                <form>
                    <GridContainer style={{ margin: '0 0 0 -15px'}}>
                        <GridItem xs={12} style={{ margin: '5px 0 0 0' }}>
                            Modify access to this file
                        </GridItem>
                        <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                            <div style={{overflowY: 'scroll', height: '400px', marginBottom: '15px'}}>
                                {fileAccounts.map((account) => {
                                    return (
                                    <div style={{display:'flex', flexDirection:'row'}}>
                                    <Checkbox 
                                        icon={icon} 
                                        id={account.accountEmail}
                                        checkedIcon={checkedIcon} 
                                        style={{ marginRight: 8, color: 'gray' }}
                                        disabled={!account.canBeEdited}
                                        onChange={(event) => this.handleSelectChange(account.accountEmail)(event)}
                                        checked={this.state.pickedAccounts.includes(account.accountEmail)} 
                                        inputProps={{
                                            style: {
                                            opacity: 0,
                                            appearance: 'none',
                                            WebkitAppearance: 'none',
                                            MozAppearance: 'none'
                                            }
                                        }}
                                        />
                                    <div style={{paddingTop: '10px', paddingBottom: '10px', paddingRight: '15px'}}>{account.accountEmail}</div>
                                    </div>);
                                })}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
								<Button
									className='deleteSystemCloseButton'
									simple
									color='info'
									onClick={()=>{setModifyAccessAlert(<></>);}}
								>
									Cancel
								</Button>
                                <Button
                                    color='info'
                                    onClick={()=>this.submitForm()}
                                >
                                    Save
                                </Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                </form>
            </CardBody >
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
      filesAccounts: state.dashboard.fileAccounts
    };
  };
  
  const actions = {
    setFileAccounts
  };
  
export default connect(null, actions)(FileAccess);
